import { isSameDay, startOfDay } from 'date-fns';
import { type QuickRangeId, type QuickRangeOption, QUICK_RANGE_OPTIONS } from 'common/components';
import type { DateRangeType } from '../../../../AgenticWorkflowDetail.types';
import { getDateRangeForRangeType } from '../../../../utils';

const CALL_ANALYTICS_QUICK_RANGE_IDS: QuickRangeId[] = ['today', 'yesterday', 'last7', 'last30'];

export const CALL_ANALYTICS_QUICK_RANGE_OPTIONS: QuickRangeOption[] = QUICK_RANGE_OPTIONS.filter((option) =>
    CALL_ANALYTICS_QUICK_RANGE_IDS.includes(option.id)
);

export const quickRangeIdToCallAnalyticsDateRangeType = (quickRangeId: QuickRangeId | null): DateRangeType => {
    switch (quickRangeId) {
        case 'today':
            return 'today';
        case 'yesterday':
            return 'yesterday';
        case 'last7':
            return 'last7days';
        case 'last30':
            return 'last30days';
        default:
            return 'custom';
    }
};

export const isNext30DaysRange = (startDate: Date, endDate: Date): boolean => {
    const preset = getDateRangeForRangeType('next30Days');

    if (!preset) {
        return false;
    }

    return (
        isSameDay(startOfDay(startDate), startOfDay(preset[0])) && isSameDay(startOfDay(endDate), startOfDay(preset[1]))
    );
};
